export default {
	SAVE_MY_NUM(state, payload) {
		state.MessageNum = payload
	},

	LOAD_CONFIG_DATA(state, payload) {
		state.configData = payload;
	},
	SAVE_MY_HOMEBTN(state, payload) {
		state.HomebtnData = payload
  },
  SAVE_MY_HOMEBTNHR(state, payload) {
		state.HomebtnHrData = payload
	},
	SAVE_MY_MODELMES(state, payload) {
		state.MesmodelMes = payload
	},
	SAVE_MY_AXIOS_RESPONSE(state, payload) {
		state.axios_responseData = payload
	},
	SAVE_MY_MRETURN(state, payload) {
		state.MreturnData = payload
	},
	SAVE_MY_CHATDATA(state, payload) {
		state.chatDatalist = payload
	},
	SAVE_MY_SUBCONDITION(state, payload) {
		state.subConditionData = payload
	},
	SAVE_MY_ASSISTANTS(state, payload) {
		state.assistantnum = payload
	},
	SAVE_MY_ASSISTANTCHANGE(state, payload) {
		state.assistantStatus = payload
	},
	SAVE_MY_EDITACTIVE(state, payload) {
		state.editActive = payload
  },
  SAVE_MY_HPH(state,payload){
	  state.homePageHeadData = payload
  },

  SAVE_MY_DSI(state,payload){
	  state.descriptionData = payload;
  },

  SAVE_MY_DVI(state,payload){
    state.developmentData = payload;
  },
  SAVE_MY_WOI(state,payload){
    state.welfareOthersData = payload;
  },

  SAVE_MY_ELI(state,payload){
    state.locationData = payload;
  },

  SAVE_MY_LTI(state,payload){
    state.leadTeamData = payload;
  },

  SAVE_MY_EPPI(state,payload){
	  state.environmentPhotoPathData = payload;

  },
  SAVE_MY_CFI(state,payload){
    state.certificationData = payload;

  },

  SAVE_MY_PF(state,payload){
	  state.perfectFlag = payload;

  },
  SAVE_MY_CSD(state,payload){
    state.certificationStatusData = payload;
  },


	//保存当前搜索职位
   UPDATE_USER_SEARCHPOSITIONHISTORY(state, payload) {
    var arr = state.searchPositionHistory?state.searchPositionHistory:[];
    arr.push(payload);
    state.searchPositionHistory = arr;
  },
  UPDATE_GLOBAL_CONFIG(state, payload){
    state.versionConfigData = payload;

  }
}
